import {CustomerActivity} from './customer-activity';

export class CustomerActivityFactory {
  /**
   *
   * @param customerActivity
   */
  public static fromObject(customerActivity: any): CustomerActivity {
    const customer = {
      customId: customerActivity.customer.customer_id,
      name: customerActivity.customer.name,
      id: customerActivity.customer.id,
      locality: customerActivity.customer.locality,
      postalCode: customerActivity.customer.postal_code,
      fullRoute: customerActivity.customer.full_route,
      serviceFacilityId: customerActivity.customer.service_facility_id,
      serviceFacilityName: customerActivity.customer.service_facility_name,
    };

    const employee = {
      customId: customerActivity.employee.employee_id,
      name: customerActivity.employee.name,
      id: customerActivity.employee.id,
      profilePictureUrl: customerActivity.employee.profile_picture_url,
      serviceId: customerActivity.employee.service_id,
      serviceName: customerActivity.employee.service_name
    };

    const service = {
      name: customerActivity.service.name,
      id: customerActivity.service.id
    };

    return new class implements CustomerActivity {
      customer = customer;
      duration: number = customerActivity.duration;
      employee = employee;
      service = service;
      timeFrom: string = customerActivity.time_from;
      timeTo: string = customerActivity.time_to;
    };
  }

  /**
   *
   * @param customerActivities
   */
  public static fromArray(customerActivities: any[]): CustomerActivity[] {
    return customerActivities.map((_customerActivity) => {
      return this.fromObject(_customerActivity);
    });
  }
}
